import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getVendors as getVendorsApi,
    getVendorById,
    createVendor,
    updateVendor,
    deleteVendor,
} from 'helpers/api/vendor';
import { vendorApiResponseSuccess, vendorApiResponseError } from './actions';
import { VendorActionTypes } from './constants';

/**
 * Fetch Vendors
 */
function* getVendors({ payload: { limit, page, sortType } }: any): SagaIterator {
    try {
        const response = yield call(getVendorsApi, {
            limit,
            page,
            sortType,
        });

        yield put(
            vendorApiResponseSuccess(
                VendorActionTypes.GET_VENDORS,
                response.data
            )
        );
    } catch (error: any) {
        yield put(vendorApiResponseError(VendorActionTypes.GET_VENDORS, error));
    }
}

/**
 * Create Vendor
 */
function* addVendorSaga({ payload }: any): SagaIterator {
    try {
        const response = yield call(createVendor, payload);

        yield put(
            vendorApiResponseSuccess(
                VendorActionTypes.ADD_VENDOR,
                response.data
            )
        );
    } catch (error: any) {
        yield put(vendorApiResponseError(VendorActionTypes.ADD_VENDOR, error));
    }
}

/**
 * Get Vendor By Id
 */
function* getVendorByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(getVendorById, action.payload);

        yield put(
            vendorApiResponseSuccess(
                VendorActionTypes.GET_VENDOR_BY_ID,
                response.data
            )
        );
    } catch (error: any) {
        yield put(vendorApiResponseError(VendorActionTypes.GET_VENDOR_BY_ID, error));
    }
}

/**
 * Update Vendor
 */
function* updateVendorSaga(action: any): SagaIterator {
    try {
        const { id, ...body } = action.payload;

        const response = yield call(updateVendor, id, body);

        yield put(
            vendorApiResponseSuccess(
                VendorActionTypes.UPDATE_VENDOR,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            vendorApiResponseError(
                VendorActionTypes.UPDATE_VENDOR,
                error
            )
        );
    }
}
/**
 * Delete Vendor
 */
function* deleteVendorSaga(action: any): SagaIterator {
    try {
        const response = yield call(deleteVendor, action.payload);

        yield put(
            vendorApiResponseSuccess(
                VendorActionTypes.DELETE_VENDOR,
                response.data
            )
        );
    } catch (error: any) {
        yield put(vendorApiResponseError(VendorActionTypes.DELETE_VENDOR, error));
    }
}

function* bulkImportVendorsSaga({ payload: { vendors } }: any): SagaIterator {
    try {
        const total = vendors.length;
        const errors: string[] = [];
        
        for (let i = 0; i < total; i++) {
            try {
                yield call(createVendor, vendors[i]);
                yield put({
                    type: VendorActionTypes.API_RESPONSE_SUCCESS,
                    payload: { actionType: '@@vendor/BULK_IMPORT_PROGRESS', progress: Math.round(((i + 1) / total) * 100) }
                });
            } catch (err: any) {
                errors.push(`Row ${i + 1}: ${err?.response?.data?.message || err.message || 'Failed'}`);
            }
        }
        
        if (errors.length === total) {
            yield put(vendorApiResponseError(VendorActionTypes.BULK_IMPORT_VENDORS, errors.join('; ')));
        } else {
            yield put(vendorApiResponseSuccess(VendorActionTypes.BULK_IMPORT_VENDORS, {}));
            if (errors.length > 0) {
                yield put(vendorApiResponseError(VendorActionTypes.BULK_IMPORT_VENDORS, errors.join('; ')));
            }
        }
    } catch (error: any) {
        yield put(vendorApiResponseError(VendorActionTypes.BULK_IMPORT_VENDORS, error?.message || 'Failed to import'));
    }
}

/* Watchers */

export function* watchGetVendors() {
    yield takeEvery(VendorActionTypes.GET_VENDORS, getVendors);
}

export function* watchAddVendor() {
    yield takeEvery(VendorActionTypes.ADD_VENDOR, addVendorSaga);
}

export function* watchGetVendorById() {
    yield takeEvery(VendorActionTypes.GET_VENDOR_BY_ID, getVendorByIdSaga);
}

export function* watchUpdateVendor() {
    yield takeEvery(VendorActionTypes.UPDATE_VENDOR, updateVendorSaga);
}

export function* watchDeleteVendor() {
    yield takeEvery(VendorActionTypes.DELETE_VENDOR, deleteVendorSaga);
}

export function* watchBulkImportVendors() {
    yield takeEvery(VendorActionTypes.BULK_IMPORT_VENDORS, bulkImportVendorsSaga);
}

/* Root Saga */

function* vendorSaga() {
    yield all([
        fork(watchGetVendors),
        fork(watchAddVendor),
        fork(watchGetVendorById),
        fork(watchUpdateVendor),
        fork(watchDeleteVendor),
        fork(watchBulkImportVendors),
    ]);
}

export default vendorSaga;